<script setup>
const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  live: {
    type: Boolean,
    required: true,
  },
});

const userStore = useUserStore();
const modalStore = useModalStore();

const { $localApi } = useNuxtApp();

const loading = ref(false);

const isLive = ref(props.live);

if (userStore.GET_INSTANT_LIVE_ID === props.id) {
  watch(
    () => userStore.GET_INSTANT_LIVE_ID,
    (value) => {
      console.log(userStore.GET_INSTANT_LIVE_ID);

      isLive.value = !!value;
    },
  );
}

async function goLiveHandle() {
  loading.value = true;

  try {
    if (!userStore.IS_AUTHORIZED) {
      modalStore.SHOW_MODAL({ component: 'MoleculeModalNeedAuth' });
      return;
    }

    const { error } = await $localApi.post(
      `/event/${props.id}/${isLive.value ? 'stop' : 'start'}/`,
    );

    if (error.value) {
      return;
    }

    if (props.id === userStore.GET_INSTANT_LIVE_ID) {
      userStore.SET_INSTANT_LIVE_ID(isLive.value ? null : props.id);
    }

    isLive.value = !isLive.value;
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
  }
}
</script>

<template>
  <button
    class="relative rounded-lg p-1 hover:scale-105 hover:bg-gray-300/10 focus:bg-gray-300/10 active:scale-95 active:bg-gray-300/20 md:p-2"
    :class="{ 'cursor-progress bg-gray-300/10': loading }"
    @click="goLiveHandle"
  >
    <MoleculeNuxtIcon
      class="size-7"
      :class="{
        'opacity-50': loading,
        'fill-green-400': isLive,
        'fill-red-400': !isLive,
      }"
      name="golive"
    />

    <span class="sr-only">Go Live</span>
    <AtomLoaderCircle
      v-if="loading"
      class="absolute inset-1/2 size-5 -translate-x-1/2 -translate-y-1/2"
    />
  </button>
</template>
